import axios from 'axios'

// 收银端大屏接口
// GET /api/cashier/dashboard?action=summary&store_id={旧库门店ID}&id={收银端门店ID}
// 说明：仅当传入 id 时，后端切换为收银新口径；否则保持旧口径
export async function getCashierDashboard(params) {
  const { store_id, id, action = 'summary' } = params || {}
  if (!store_id) {
    throw new Error('store_id 是必填参数')
  }

  const queryParams = { action, store_id }
  if (id) {
    queryParams.id = id
  }

  const response = await axios.get('https://api.shangbokangsc.com/api/cashier/dashboard', { params: queryParams })
  // 后端已保证结构与旧接口一致：直接返回顶层 data
  return response.data
}